import './App.sass';
import './i18n';
import { Container } from 'react-bootstrap';
import { Header } from './components/header/header';
import { FaqSection } from './components/faq/faq-section';
import { Provider } from './components/provider/provider-section';
import { ContactUs } from './components/contact-us/contact-us-section';
import { Customer } from './components/customer/customer-section';
import { Services_top } from './components/services/services-top';
import { Services_card_1 } from './components/services/services-card-1';
import { Services_bottom } from './components/services/services-bottom';
import { Footer } from './components/footer/footer';
import { Services_card_2 } from './components/services/services-card-2';
import { BrowserRouter as Router, Route, Routes } from 'react-router';
import { AboutUs } from './components/about-us/about-us';
import { Privacy } from './components/privacy-terms/privacy-policy';
import { Terms } from './components/privacy-terms/terms-conditions';
import ScrollToTop from './components/scroll-to-top';
import DeleteAccount from './components/delete-account/delete-account';

function App() {
  return (
    <Router>
      <Container fluid>
        <div className="App">
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              {/* Dedicated Pages Routes */}
              <Route path="/about" element={<AboutUs />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/delete-account" element={<DeleteAccount />} />

              {/* Home Page with Scrollable Sections */}
              <Route
                path="/"
                element={
                  <>
                    <div id="customer">
                      <Customer />
                    </div>
                    <div className="services-container">
                      <div id="services-top">
                        <Services_top />
                      </div>
                      <div id="services-card-1">
                        <Services_card_1 />
                      </div>
                      <div id="services-bottom">
                        <Services_bottom />
                      </div>
                      <div id="services-card-2">
                        <Services_card_2 />
                      </div>
                    </div>
                    <hr />
                    <div id="provider">
                      <Provider />
                    </div>
                    <hr />
                    <div id="faq">
                      <FaqSection />
                    </div>
                    <hr />
                    <div id="contact">
                      <ContactUs />
                    </div>
                  </>
                }
              />
            </Routes>
          </main>
          <Footer />
        </div>
      </Container>
    </Router>
  );
}

export default App;
